import { useState } from "react";
import { Plug } from "lucide-react";
import { findConnector, logoURL } from "@/lib/connectorCatalog";
import { cn } from "@/lib/utils";

// IntegrationLogo renders the brand logo for an integration/server name (resolved
// via the connector catalog), falling back to a neutral plug tile for custom MCP
// servers or when the image can't load.
export function IntegrationLogo({ name, className }: { name: string; className?: string }) {
  const connector = findConnector(name);
  const [failed, setFailed] = useState(false);
  if (!connector || failed) {
    return (
      <span className={cn("flex h-7 w-7 shrink-0 items-center justify-center rounded-md border bg-muted text-muted-foreground", className)}>
        <Plug className="h-3.5 w-3.5" />
      </span>
    );
  }
  return (
    <span className={cn("flex h-7 w-7 shrink-0 items-center justify-center overflow-hidden rounded-md border bg-white", className)}>
      <img src={logoURL(connector)} alt="" width={16} height={16} className="h-4 w-4 object-contain" onError={() => setFailed(true)} />
    </span>
  );
}
